import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=40d30b32&scoped=true&"
import script from "./handle.vue?vue&type=script&lang=js&"
export * from "./handle.vue?vue&type=script&lang=js&"
import style0 from "./handle.vue?vue&type=style&index=0&id=40d30b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d30b32",
  null
  
)

export default component.exports